import { useTranslation } from 'react-i18next';

import { HeaderNotification } from './HeaderNotification';
import { useRefinanceAmounts } from './hooks/useRefinanceAmounts';
import { currencyFormat } from '~/lib/i18n';

type Props = {
    coApplicantHidden: boolean;
};

export const RefinancePlannerNotifications = ({ coApplicantHidden }: Props) => {
    const { t } = useTranslation();
    const { availableCredit, totalFinancedAmount } = useRefinanceAmounts(coApplicantHidden);

    return (
        <div className="flex flex-wrap justify-end gap-2">
            <HeaderNotification
                displayName={t('BANK_CREDIT_REQUEST.REFINANCE_PLANNER.REFINANCE')}
                value={currencyFormat(totalFinancedAmount)}
            />
            <HeaderNotification
                displayName={t('BANK_CREDIT_REQUEST.REFINANCE_PLANNER.AVAILABLE_MONEY')}
                value={currencyFormat(availableCredit)}
            />
        </div>
    );
};
